import { createApi } from "@reduxjs/toolkit/query/react";
import { privateBaseQuery } from "@/api/base/private/privateBaseQuery";

export interface Currency {
  id: number;
  name: string;
  icon: string | null;
  currency: string;
  code: number;
  template: string;
  is_default: number;
}

interface CurrenciesResponse {
  status: string;
  status_code: string;
  entities: Currency[];
}

export const currenciesApi = createApi({
  reducerPath: "currenciesApi",
  baseQuery: privateBaseQuery(),
  tagTypes: ["Currencies"],
  endpoints: (builder) => ({
    getCurrencies: builder.query<Currency[], void>({
      query: () => ({
        url: "/currencies",
        method: "GET",
      }),
      transformResponse: (response: CurrenciesResponse) => response.entities,
      providesTags: (result) =>
        result
          ? [
              ...result.map((c) => ({
                type: "Currencies" as const,
                id: c.id,
              })),
              { type: "Currencies" as const, id: "LIST" },
            ]
          : [{ type: "Currencies" as const, id: "LIST" }],
    }),
  }),
});

export const { useGetCurrenciesQuery } = currenciesApi;
